<app-dialog [dialogWithInput]="dialog" [manualCloseManagement]="true" (closeEvent)="close()">
    <app-card title="Etiquettes disponibles">
        <app-service-container [service]="findAllService">
            <div class="d-flex gap-5 m-t-8" style="max-height: 400px; overflow-y: auto;">
                <div *ngFor="let tag of tags">
                    <div (click)="clicked(tag)" class="p-4" style="background: white;
                        cursor: pointer;
                        border-style: solid; border-width: 2px; border-radius: 50%;
                        display: inline-block;"
                         [style.border-color]="tag.selected ? 'black' : 'white'">
                        <app-tag-field  [tag]="tag.tag"></app-tag-field>
                    </div>
                    <p style="text-align: center; margin: 0;"
                        [style.color]="tag.tag.color">{{tag.tag.name}}</p>
                </div>
                <ng-container *ngIf="tags?.length === 0">
                    Aucune étiquette
                </ng-container>
            </div>
        </app-service-container>
    </app-card>
    <ng-container dialog-actions>
        <app-button iconName="settings" (clickEvent)="settings()" tooltip="Gérer les étiquettes"></app-button>
        <app-button iconName="plus" (clickEvent)="newTag()" tooltip="Créer une nouvelle étiquette"></app-button>
        <app-action-button
                [buildPayload]="buildPayload"
                fill="solid"
                [confirmationOptions]="undefined"
                [service]="saveService"
                (actionSuccessEvent)="dialog.close()"
                iconName="check" label="Enregistrer"
                *ngIf="!(findAllService.loading$ | async)">
        </app-action-button>
    </ng-container>
</app-dialog>